import moment from 'moment-timezone';

import { Event } from '../interfaces';
import { getTimeOffset } from './getTimeOffset';

export const getTimeBetweenEvents = (originalEvent: Event, currentEvent: Event, timezone: string): string => {
  if (!originalEvent || !currentEvent) {
    return '';
  }
  return `${moment.tz(currentEvent.captured_at, timezone).format('hh:mm:ss A')} (${getTimeOffset(originalEvent, currentEvent)})`;
};
